import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Chevron from '../../../assets/chevron.svg';
import ChevronLeft from '../../../assets/chevron-left.svg';
import Details from '../../../assets/details.svg';
import Post from '../../../assets/post.svg';
import Gallery from '../../../assets/gallery.svg';

const StyledNavbar = styled.nav`
  display: grid;
  align-items: center;

  border-radius: var(--border-radius);
  background-color: var(--glass-bg);
  backdrop-filter: var(--glass-filter);
  box-shadow: var(--glass-glow);
  border: var(--glass-border);
  min-width: 8.5rem;
`;

const StyledNavbarLink = styled.a`
  display: flex;
  gap: var(--spacer);

  align-items: center;
  outline: inherit;
  padding: var(--spacer-small);
  border: none;
  color: inherit;
  cursor: pointer;
  max-width: 100vw;
  background-color: transparent;

  transition: all 250ms ease-in;

  border-radius: var(--border-radius);

  :hover {
    background-color: var(--glass-bg-hover);
    box-shadow: var(--glass-glow-hover);
  }

  svg {
    width: 2rem;
    border-radius: 50%;
  }
`;

export default function Nav({ className, nav }) {
  return (
    <StyledNavbar className={className}>
      {nav.back && (
        <StyledNavbarLink href="#back" onClick={() => window?.history?.back()}>
          <ChevronLeft />
          <span>Zurück</span>
        </StyledNavbarLink>
      )}
      {nav.top && (
        <StyledNavbarLink href="#top">
          <Chevron />
          <span>Top</span>
        </StyledNavbarLink>
      )}
      {nav.article && (
        <StyledNavbarLink href="#article">
          <Post />
          <span>Post</span>
        </StyledNavbarLink>
      )}
      {nav.infos && (
        <StyledNavbarLink href="#infos">
          <Details />
          <span>Infos</span>
        </StyledNavbarLink>
      )}
      {nav.gallery && (
        <StyledNavbarLink href="#gallery">
          <Gallery />
          <span>Gallerie</span>
        </StyledNavbarLink>
      )}
    </StyledNavbar>
  );
}

Nav.propTypes = {
  nav: PropTypes.shape({
    top: PropTypes.bool,
    article: PropTypes.bool,
    infos: PropTypes.bool,
    gallery: PropTypes.bool,
  }),
};

Nav.defaultProps = {
  nav: PropTypes.shape({
    top: false,
    article: false,
    infos: false,
    gallery: false,
    back: true,
  }),
};
